var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',[_c('v-flex',[(_vm.showAlert == true)?_c('div',[_c('alert-empty')],1):_vm._e(),_c('v-widget',{key:_vm.indexChart,staticClass:"px-0",attrs:{"title":_vm.tituloGrafica,"content-bg":"white"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
              ['dataset.source', _vm.res],
              ['tooltip.trigger', 'axis'],
              ['tooltip.axisPointer', { type: 'shadow' }],
              [
                'color',
                [_vm.color.lightBlue.base, _vm.color.orange.base, _vm.color.grey.base],
              ],
              ['legend.show', true],
              ['xAxis.axisLabel.show', true],
              ['xAxis.type', 'value'],
              ['yAxis.axisLabel.show', true],
              ['yAxis.type', 'category'],
              ['yAxis.data', _vm.regiones],
              ['grid.left', '3%'],
              ['grid.bottom', '3%'],
              ['grid.right', '4%'],
              ['series[0].type', 'bar'],
              ['series[0].areaStyle', {}],
              ['series[0].areaStyle', {}],
              //  ['series[0].label', {normal: { show: true, position: 'insideRight'} }],
              ['series[0].smooth', true],
              ['series[1].type', 'bar'],
              ['series[1].areaStyle', {}],
              ['series[1].smooth', true],
              //['series[1].label', {normal: { show: true, position: 'insideRight'} }],
              ['series[2].type', 'bar'],
              ['series[2].areaStyle', {}],
              ['series[2].smooth', true],
              //['series[2].label', {normal: { show: true, position: 'insideRight'} }],
            ],"height":"400px","width":"100%"}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }